<template>
  <div :style="styleObj" class="model-bd">
    <div class="cont-comp-loading" v-if="loading">
      <a-spin :spinning="loading"></a-spin>
    </div>
    <div class="widget-time" v-show="dateRang && dateRang.length > 0">
			<TagDateRange size="small" v-model="dateRang"  @change="onChange"></TagDateRange>
    </div>
    <v-chart ref="barchart" :options="options" autoresize/>
  </div>
</template>

<script>
import moment from 'moment';
import TagDateRange from "@/components/TagDateRange";
import { barOrLineChartFn } from "@/utils/modelMethods";

export default {
  name: "WidgetBarchart",
  components: {},
  props: {
    value: Object,
    ispreview: Boolean,
  },
  components: {
    TagDateRange
  },
  data() {
    return {
      options: {
        grid: {},
        legend: {
          textStyle: {
            color: "#333",
          },
        },
        xAxis: {
          type: "category",
          data: [],
          axisLabel: {
            show: true,
            textStyle: {
              color: "#333",
            },
          },
        },
        yAxis: {
          type: "value",
          data: [],
          axisLabel: {
            show: true,
            textStyle: {
              color: "#333",
            },
          },
        },
        series: [
          {
            data: [],
            type: "bar",
            barGap: "0%",
            itemStyle: {
              borderRadius: null,
            },
          },
        ],
      },
      optionsStyle: {}, // 样式
      optionsData: {}, // 数据
      optionsSetup: {},
      flagInter: null,
      flagIndex:1,
      flag: false,
      loading: false,
      // 时间组件
      dateRang: [],
      timeSelector: "",
      refresh: false,
    };
  },
  inject: ["getDashboardDynamicData", "getFilterCondition"],
  computed: {
    dashbordData() {
      return this.getDashboardDynamicData()?.contextData || {}
    },
    styleObj() {
      return {
        position: this.ispreview ? "absolute" : "static",
        width: this.optionsStyle.width + "px",
        height: this.optionsStyle.height + "px",
        left: this.optionsStyle.left + "px",
        top: this.optionsStyle.top + "px",
        background: this.optionsSetup.background,
      };
    },
  },
  watch: {
    value: {
      handler(val) {
        console.log(val, "val-bar-value-------------------");
        this.optionsStyle = val.position;
        let flag = this.optionsData === val.data && !this.optionsData?.dynamicData?.chartProperties?.isVerified
        this.optionsData = val.data;
        this.optionsSetup = val.setup;
        if(this.ispreview && this.isContCompDate(this.optionsData)) {
          // console.log(222)
        }else {
          this.editorOptions(flag);
          this.editorDataSet();
        }
        // debugger;
        
      },
      deep: true,
    },
  },
  mounted() {
    this.optionsStyle = this.value.position;
    this.optionsData = this.value.data;
    this.optionsSetup = this.value.setup;
    this.editorOptions();
    // this.editorDataSet();
  },
  methods: {
    disabledDate(current) {
      return current && current > moment().endOf('day');
    },
    filterSearch() {
      this.getEchartData(this.optionsData.dynamicData, this.optionsSetup);
    },
    onChange(val, timeSelector) {
      if(this.ispreview){
        const optionsSetup = this.optionsSetup;
        const optionsData = this.optionsData;
        const dataSet = this.optionsData.dynamicData.contextData;
        dataSet.dateRang.from = val[0];
        dataSet.dateRang.to = val[1];
        dataSet.dateRang.timeSelector = timeSelector;
        // this.editorDataSet();
        this.getEchartData(optionsData.dynamicData, optionsSetup);
      }
    },
    previewInit(data) {
      
      if(this.isContCompDate(this.optionsData)){
        if(!this.flag){
          this.setBarFromResponse(data)
          this.flag = true;
        }
      }else {
        this.setBarFromResponse(data)
      }
    },
    setBarFromResponse(res) {
      // console.log(res, 'setBarFromResponse')
      const optionsSetup = this.optionsSetup;
      const params = this.optionsData.dynamicData.params;
      const dataParams = this.optionsData.dynamicData.contextData;
      const combineData = barOrLineChartFn(params.widgetType, dataParams, res);
      new Promise((resolve, reject) => {
        resolve(combineData)
      }).then(response => {
        this.renderingFn(optionsSetup, response);
      })
    },
    editorDataSet(){
      // 获取数据的配置项；
      const dataSet = this.optionsData.dynamicData.contextData;
      
      // 设置日期响应
      if(!!dataSet && dataSet.dateRang.from && dataSet.dateRang.to){
        let dateRang = [];
        dateRang[0] = dataSet.dateRang.from;
        dateRang[1] = dataSet.dateRang.to;
        this.$set(this.dateRang, 0, dateRang[0])
        this.$set(this.dateRang, 1, dateRang[1])
        this.timeSelector = dataSet.dateRang.timeSelector
      }else {
        this.dateRang = [];
        this.timeSelector = ''
      }
    },
    // 修改图标options属性
    editorOptions(flag) {
      this.setOptionsTitle();
      this.setOptionsX();
      this.setOptionsY();
      this.setOptionsTop();
      this.setOptionsTooltip();
      this.setOptionsMargin();
      this.setOptionsLegend();
      this.setOptionsColor();
      !flag&&this.setOptionsData();

      if(this.flagIndex <= 6 ){
        this.flagIndex ++;
      }
    },
    // 标题修改
    setOptionsTitle() {
      const optionsSetup = this.optionsSetup;
      const title = {};
      title.text = optionsSetup.titleText;
      title.show = true;
      title.left = optionsSetup.textAlign || 'left';
      title.textStyle = {
        color: optionsSetup.textColor || "#13234C",
        fontSize: optionsSetup.textFontSize || 16,
        fontWeight: optionsSetup.textFontWeight || 400,
      };
      title.subtext = optionsSetup.subText;
      title.subtextStyle = {
        color: optionsSetup.subTextColor,
        fontWeight: optionsSetup.subTextFontWeight,
        fontSize: optionsSetup.subTextFontSize,
      };
      title.padding = [16, 24, 8, 24];
      this.options.title = title;
    },
    // X轴设置
    setOptionsX() {
      const optionsSetup = this.optionsSetup;
      const xAxis = {
        ...this.options.xAxis,
        type: "category",
        show: optionsSetup.hideX, // 坐标轴是否显示
        name: optionsSetup.xName, // 坐标轴名称
        nameTextStyle: {
          color: optionsSetup.xNameColor,
          fontSize: optionsSetup.xNameFontSize,
        },
        nameRotate: optionsSetup.textAngle, // 文字角度
        inverse: optionsSetup.reversalX, // 轴反转
        axisLabel: {
          show: true,
          interval: optionsSetup.textInterval || 0, // 文字角度
          rotate: optionsSetup.textAngle, // 文字角度
          textStyle: {
            color: optionsSetup.Xcolor, // x轴 坐标文字颜色
            fontSize: optionsSetup.fontSizeX,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: optionsSetup.lineColorX,
          },
        },
        axisPointer: {
          show: true,
          lineStyle: {
            color: 'transparent',
          },
        },
        splitLine: {
          show: optionsSetup.isShowSplitLineX,
          type: 'dotted',
          lineStyle: {
            color: optionsSetup.splitLineColorX,
          },
        },
      };
      this.options.xAxis = xAxis;
    },
    // Y轴设置
    setOptionsY(multipleY = false) {
      const optionsSetup = this.optionsSetup;
      let yAxis = [];
      let initYAxis = {
        type: "value",
        scale: optionsSetup.scale,
        splitNumber: optionsSetup.splitNumber, // 均分
        show: optionsSetup.isShowY, // 坐标轴是否显示
        name: optionsSetup.textNameY, // 坐标轴名称
        min: optionsSetup.min || undefined, // 最小值
        minInterval: optionsSetup.minInterval || undefined, // 最小间隔
        position: 'left',
        nameTextStyle: {
          color: optionsSetup.nameColorY,
          fontSize: optionsSetup.nameFontSizeY,
        },
        inverse: optionsSetup.reversalY, // 轴反转
        axisLabel: {
          show: true,
          
          rotate: optionsSetup.ytextAngle, // 文字角度
          textStyle: {
            color: optionsSetup.colorY, // x轴 坐标文字颜色
            fontSize: optionsSetup.fontSizeY,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: optionsSetup.lineColorY,
          },
        },
        splitLine: {
          show: optionsSetup.isShowSplitLineY,
          lineStyle: {
            type: 'dashed',
            color: optionsSetup.splitLineColorY,
          },
        },
      };
      // 对于设置了多y轴的配置，需要重新组装y轴配置
      if(multipleY){
        let options = this.options;
        let series = this.options.series;
        const dataParams = this.optionsData.dynamicData.contextData;
        const secondaryAxis = dataParams.secondaryAxis
        console.log(options, series, dataParams, 'secondaryAxis');
        series.forEach(item => {
          let obj = this.$deepclone(initYAxis);
          // obj.name = item.name;
          if( item.type === 'line' && series.length === 2){
            obj.position = 'right';
          }
          yAxis.push(obj);
        })
      }else {
        yAxis = initYAxis
      }
      this.options.yAxis = yAxis;
    },
    // 数值设定 or 柱体设置
    setOptionsTop() {
      const optionsSetup = this.optionsSetup;
      const series = this.options.series;
      if (series[0].type == "bar") {
        if (optionsSetup.verticalShow) {
          series[0].label = {
            show: optionsSetup.isShow,
            position: "right",
            distance: optionsSetup.distance,
            textStyle: {
              fontSize: optionsSetup.fontSize,
              color: optionsSetup.subTextColor,
              fontWeight: optionsSetup.fontWeight,
            },
            
          };
        } else {
          series[0].label = {
            show: optionsSetup.isShow,
            position: "inside",
            distance: optionsSetup.distance,
            fontSize: optionsSetup.fontSize,
            color: optionsSetup.subTextColor,
            fontWeight: optionsSetup.fontWeight,
            
          };
        }
      }
      series[0].barWidth = optionsSetup.maxWidth;
      series[0].barMinHeight = optionsSetup.minHeight;
    },
    // tooltip 设置
    setOptionsTooltip() {
      const optionsSetup = this.optionsSetup;
      const tooltip = {
        trigger: "axis",
        show: true,
        backgroundColor: 'rgba(45, 52, 70, 0.96)',
        extraCssText:'text-align: left;',
        textStyle: {
          color: optionsSetup.lineColor || '#FFFFFF',
          fontSize: '14px',
        },
        formatter: (params) =>this.$formatChartTooltip(params)
      };
      this.options.tooltip = tooltip;
    },
    // 边距设置
    setOptionsMargin() {
      const optionsSetup = this.optionsSetup;
      // debugger;
      const grid = {
        left: optionsSetup.marginLeft || 24,
        right: optionsSetup.marginRight || 24,
        bottom: optionsSetup.marginBottom || 14,
        top: optionsSetup.marginTop || 106,
        containLabel: true,
      };
      this.options.grid = grid;
    },
    // 图例操作 legend
    setOptionsLegend() {
      const optionsSetup = this.optionsSetup;
      const legend = this.options.legend;
      legend.show = optionsSetup.isShowLegend || true;
      legend.left = optionsSetup.lateralPosition || "right";
      legend.right = optionsSetup.lateralPosition || 24;
      legend.top = optionsSetup.longitudinalPosition || 40;
      legend.bottom = optionsSetup.longitudinalPosition || "top";
      legend.orient = optionsSetup.layoutFront || "horizontal";
      legend.textStyle = {
        color: optionsSetup.lengedColor || "#677392",
        fontSize: optionsSetup.fontSize,
      };
      legend.padding = [14, 24, 14, 0 ]
      legend.itemWidth = optionsSetup.lengedWidth || 12;
    },
    // 图例名称设置
    setOptionsLegendName(name) {
      const optionsSetup = this.optionsSetup;
      const series = this.options.series;
      const legendName = optionsSetup.legendName;
      // 图例没有手动写则显示原值，写了则显示新值
      if (null == legendName || legendName == "") {
        for (let i = 0; i < name.length; i++) {
          series[i].name = name[i];
        }
        this.options.legend["data"] = name;
      } else {
        const arr = legendName.split("|");
        for (let i = 0; i < arr.length; i++) {
          series[i].name = arr[i];
        }
        this.options.legend["data"] = arr;
      }
    },
    // 图例颜色修改
    setOptionsColor() {
      const isCompare = this.optionsData.dynamicData.contextData && this.optionsData.dynamicData.contextData.calc ? this.optionsData.dynamicData.contextData.calc.compare : false;
      const optionsSetup = this.optionsSetup;
      const defaultColor = isCompare ? this.$enum.ChartCompareColor :  this.$enum.ChartDefaultColor;
      this.options.color = isCompare ? this.$enum.ChartCompareOptionsColor : this.$enum.ChartOptionsColor;
      const customColor = optionsSetup.customColor
        ? optionsSetup.customColor
        : defaultColor;
      if (!customColor) return;
      const arrColor = [];
      for (let i = 0; i < customColor.length; i++) {
        arrColor.push(customColor[i].color);
      }
      const itemStyle = {
        normal: {
          color: (params) => {
            return arrColor[params.seriesIndex];
          },
          barBorderRadius:  [optionsSetup.radius, optionsSetup.radius, 0, 0],
        },
      };
      const series =this.options.series
      for (let i = 0; i < series.length; i++) {
          series[i].itemStyle = itemStyle;
        // if (series[i].type == "bar") {
        // }
      }
      this.options = Object.assign({}, this.options);
    },
    // 数据解析
    setOptionsData() {
      const optionsSetup = this.optionsSetup;
      const optionsData = this.optionsData; // 数据类型 静态 or 动态
      if (optionsData.dataType == "staticData") {
        this.staticDataFn(optionsData.staticData);
      } else if (optionsData.dataType == "dynamicData") {
        let oneTime = this.$once(this.staticDataFn);
        oneTime(optionsData.staticData);
        // debugger;
        // 如果是新的数据，则还是利用旧数据进行渲染；
        if (optionsData.dynamicData && optionsData.dynamicData.contextData) {
          this.dynamicDataFn(
            optionsData.dynamicData,
            optionsData.refreshTime,
            optionsSetup
          );
        }
      }
    },
    // 静态数据
    staticDataFn(val) {
      const optionsSetup = this.optionsSetup;
      const series = this.options.series;
      let axis = [];
      let data = [];
      for (const i in val) {
        axis[i] = val[i].axis;
        data[i] = val[i].data;
      }
      // x轴
      if (optionsSetup.verticalShow) {
        this.options.xAxis.data = [];
        this.options.yAxis.data = axis;
        this.options.xAxis.type = "value";
        this.options.yAxis.type = "category";
      } else {
        this.options.xAxis.data = axis;
        this.options.yAxis.data = [];
        this.options.xAxis.type = "category";
        this.options.yAxis.type = "value";
      }
      if (series[0].type == "bar") {
        series[0].data = data;
      }
      const legendName = [];
      legendName.push("销售量");
      this.options.legend["data"] = legendName;
      this.setOptionsLegendName(legendName);
    },
    // 动态数据
    dynamicDataFn(val, refreshTime, optionsSetup) {
      // debugger;
      // debugger;
      if (this.ispreview) {
        this.editorDataSet();
      } else {
        if(val.chartProperties.isDrag){
          this.getEchartData(val, optionsSetup);
        }
        console.log(val.chartProperties.isVerified, 'val.chartProperties')
        if (!val || !val.chartProperties || val.chartProperties.isVerified === false) return;
        this.getEchartData(val, optionsSetup);
      }
    },
    getEchartData(val, optionsSetup) {
      this.loading = true;
      const data = this.queryEchartsData(
        val.contextData,
        val.params,
        val.chartProperties
      );
      data.then((res) => {
        this.loading = false;
        this.renderingFn(optionsSetup, res);
      }).catch(err => {
        this.loading = false;
      });
    },
    renderingFn(optionsSetup, val) {
      const optionsData = this.optionsData;
      if(val.xAxis.length === 0 || val.series.length === 0) {
        this.staticDataFn(optionsData.staticData);
        return;
      }
      // x轴
      if (optionsSetup.verticalShow) {
        this.options.xAxis.data = [];
        this.options.yAxis.data = val.xAxis;
        this.options.xAxis.type = "value";
        this.options.yAxis.type = "category";
      } else {
        this.options.xAxis.data = val.xAxis;
        this.options.yAxis.data = [];
        this.options.xAxis.type = "category";
        this.options.yAxis.type = "value";
       
      }
      // series
      const series = this.options.series;
      const legendName = [];
      // debugger;
      const newSeries = []
      const that  = this;
      if(series && series.length > 0 && val.series) {
        const valLen = val.series.length
        val.series.forEach((item,index) => {
          console.log(item, 'item');
          newSeries[index] = {  ...series[0], name: '', data: [], yAxisIndex: item.yAxisIndex}
          console.log(val, 'val')
          if (newSeries[index].type == "bar" || newSeries[index].type == "line") {
            newSeries[index].type = item.type
            newSeries[index].name = valLen > 0 ?  val.series[index].name : null;
            newSeries[index].data = valLen > 0 ? val.series[index].data.map((v,i) => ({
              ...v,
              yName: val.xAxis[i]
            })) : [];
            // console.log(lineNorm)
            newSeries[index].itemStyle = {
              normal: { 
                label: {
                  show: optionsSetup.isShow,
                  position: "top",
                  distance: optionsSetup.distance,
                  fontSize: optionsSetup.fontSize,
                  color: optionsSetup.subTextColor,
                  fontWeight: optionsSetup.fontWeight,
                  formatter: function(params) {
                    const value = params.value;
                    let formatValue = that.$getThousandths(value)
                    return formatValue;
                  }
                },
                barBorderRadius:  [optionsSetup.radius, optionsSetup.radius, 0, 0],
              }
            }
            legendName.push(newSeries[index].name);
          }
        })
        // for (const i in series) {
        //   if (series[i].type == "bar") {
        //     series[i].name = val.series[i].name;
        //     series[i].data = val.series[i].data;
        //   }
        //   legendName.push(val.series[i].name);
        // }
      }
      console.log(newSeries, 'newSeries')
      this.options.series = newSeries;
      this.options.legend["data"] = legendName;
      this.setOptionsLegendName(legendName);
      this.setOptionsY(true);
    },
  },
};
</script>

<style scoped lang="less">
.echarts {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

</style>
<style lang="less">
.widget-time{
  width:220px;
  top: 16px;
  right: 24px;
  position: absolute;
  z-index: 1;
   .ant-calendar-picker {
    .ant-calendar-picker-input {
      border-radius: 6px;
    }
  }
}
</style>
